/**************************************************
 * Nombre:       Formulario_Evento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    Diamond,
    Flag,
    Google,
    LockOutline,
    MoveUpOutlined,
    PhoneAndroid,
    TitleOutlined,
    VisibilityOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";
import {RANGOSCUENTA} from "../../Constantes";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {useState} from "react";

const Formulario_Registro = ({...props}) => {
    const [tipo, settipo] = useState("password");

    const cambiar = () => {

        if (tipo === "text") {
            settipo("password");
        } else {
            settipo("text");
        }
    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                                  requerido={'El Apellido es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={Diamond} nombre={'Quien es tu diamante acendente?'}
                                  dato={'diamante'} {...props} requerido={'Tu diamante acendente es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoSelect Icono={MoveUpOutlined} nombre={'Rango'}
                                   dato={'rango'} {...props} requerido={'El Rango acendente es requerido'}
                                   opciones={RANGOSCUENTA}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                                   requerido={'Es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Num Celular'} dato={'celular'} {...props}
                                  requerido={'Tu celular es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'El correo es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTextoBoton Icono={LockOutline} nombre={'Contraseña'} dato={'pass'} {...props} type={tipo}
                                       requerido={'Campo Requerido'} click={cambiar} IconoFinal={VisibilityOutlined}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Registro